/* AUTO GLASS ELITE SHIELD - exact installed prices by year / make / model
   Works on top of the quote wizard (px-quote.js). Price data lives in
   assets/pxq-exact-data.js (window.PXQ_EXACT), built from Mygrant + Import Glass costs.
   Prices in the data file are FINAL installed prices (no costs are published). */
(function () {
  var m = document.getElementById('pxq');
  if (!m) return;
  var DATA = null, loading = false;
  var FEAT = { 'Lane camera / ADAS': 'c', 'Rain sensor': 'r', 'Heated wiper area': 'h', 'Heads-up display': 'u', 'None of these': '0', 'Not sure': '?' };
  var FEAT_ORDER = [['c', 'Lane camera / ADAS'], ['r', 'Rain sensor'], ['h', 'Heated wiper area'], ['u', 'Heads-up display']];

  function load() {
    if (DATA || loading || !window.PXQ_EXACT_DATA_URL) return;
    loading = true;
    var s = document.createElement('script');
    s.src = window.PXQ_EXACT_DATA_URL;
    s.onload = function () { DATA = window.PXQ_EXACT || null; schedule(); };
    document.head.appendChild(s);
  }
  function norm(x) { return String(x || '').toLowerCase().replace(/[^a-z0-9]/g, ''); }
  function q(s, c) { return (c || m).querySelector(s); }
  function money(n) { return '$' + Number(n).toLocaleString('en-US'); }
  function fmt(list) {
    if (!list || !list.length) return '';
    var lo = Math.min.apply(null, list), hi = Math.max.apply(null, list);
    return lo === hi ? money(lo) : money(lo) + ' – ' + money(hi);
  }
  function vehicle() {
    var y = q('[data-pxq-year]'), mk = q('[data-pxq-make]'), ms = q('[data-pxq-model]'), mt = q('[data-pxq-modeltext]');
    var model = mt && !mt.hidden ? mt.value : (ms ? ms.value : '');
    return { year: +(y && y.value), make: mk ? mk.value : '', model: model };
  }
  var KEYS = null;
  function rowFor(key, year) {
    var rows = DATA.v[key];
    if (!rows) return null;
    for (var i = 0; i < rows.length; i++) if (year >= rows[i][0] && year <= rows[i][1]) return rows[i][2];
    return null;
  }
  function candidates(mk, n) {
    if (!KEYS) { KEYS = {}; for (var k in DATA.v) { var p = k.split('|'); (KEYS[p[0]] = KEYS[p[0]] || []).push(p[1]); } }
    var list = KEYS[mk] || [], out = [];
    var add = function (k) { if (k && out.indexOf(k) < 0 && list.indexOf(k) > -1) out.push(k); };
    var al = DATA.a && DATA.a[mk + '|' + n];
    if (al) add(al.split('|')[1]);
    add(n);
    var alts = [n.replace(/^model/, ''), n.replace(new RegExp('^' + mk), ''), n.replace(/class$/, ''), n.replace(/(hybrid|plugin|phev|ev|prime)$/, ''),
      n.replace(/^(rs|s)(\d)/, 'a$2'), n.replace(/^(rs|s)(q\d)/, '$2'), n.replace(/^m(\d)(\d\d)/, '$1$2'), n.replace(/[a-z]+$/, '')];
    var bm = n.match(/^m?(\d)(\d\d)?[a-z]*$/);
    if (mk === 'bmw' && bm) { alts.push(bm[1] + 'series', bm[1] + 'seriesgrancoupe', bm[1] + 'seriesgrancoupe'); }
    alts.forEach(add);
    var byLen = function (a, b) { return a.length - b.length || (a < b ? -1 : a > b ? 1 : 0); };
    var OTHER = /connect|city|cross|sport|select|classic|crew|cargo/;
    [n].concat(alts).forEach(function (x) {
      if (!x || x.length < 1) return;
      var pre = list.filter(function (k) { return k.indexOf(x) === 0; }).sort(byLen);
      pre.filter(function (k) { return !OTHER.test(k.slice(x.length)); }).forEach(add);
      pre.forEach(add);
    });
    if (n.length >= 3) list.filter(function (k) { return k.indexOf(n) > -1; }).sort(byLen).forEach(add);
    list.filter(function (k) { return k.length >= 2 && n.indexOf(k) === 0; }).sort(function (a, b) { return b.length - a.length; }).forEach(add);
    return out;
  }
  function record() {
    if (!DATA) return null;
    var v = vehicle();
    if (!v.year || !v.make || !v.model) return null;
    var mk = norm(v.make), n = norm(v.model);
    mk = (DATA.mk && DATA.mk[mk]) || mk;
    var c = candidates(mk, n);
    for (var i = 0; i < c.length; i++) { var r = rowFor(mk + '|' + c[i], v.year); if (r) return r; }
    return null;
  }
  function all(obj) { var out = []; for (var k in obj) out = out.concat(obj[k]); return out; }
  function windshield(r, feats) {
    var opts = r.w || [];
    if (!opts.length) return [];
    var sel = feats.filter(function (f) { return f && f !== '?'; });
    if (!sel.length || feats.indexOf('?') > -1) return opts.map(function (o) { return o[1]; });
    if (sel.indexOf('0') > -1) {
      var base = opts.filter(function (o) { return o[0] === ''; });
      return (base.length ? base : opts).map(function (o) { return o[1]; });
    }
    var best = null, prices = [];
    opts.forEach(function (o) {
      if (!sel.every(function (f) { return o[0].indexOf(f) > -1; })) return;
      var extra = o[0].length - sel.length;
      if (best === null || extra < best) { best = extra; prices = [o[1]]; }
      else if (extra === best) prices.push(o[1]);
    });
    return prices.length ? prices : opts.map(function (o) { return o[1]; });
  }
  function prices(k, r, pos, feats) {
    if (k === 'windshield') return windshield(r, feats || []);
    if (k === 'door') return r.d ? (pos && r.d[pos] ? r.d[pos] : all(r.d)) : [];
    if (k === 'quarter') return r.q ? (pos && r.q[pos] ? r.q[pos] : all(r.q)) : [];
    if (k === 'back') return r.b || [];
    return [];
  }

  var busy = false;
  function apply() {
    if (!m.classList.contains('is-open')) return;
    load();
    var r = record();
    var badge = q('[data-pxq-vehcat]');
    if (!r) return;
    busy = true;
    try {
      if (badge && badge.textContent.indexOf('Exact') < 0) { badge.textContent = '✓ Exact price for your vehicle'; badge.classList.add('is-exact'); }
      var cat = q('[data-pxq-cat]');
      if (cat && cat.value.indexOf('exact') < 0) cat.value = 'Exact vehicle pricing';
      // service tiles
      Array.prototype.forEach.call(m.querySelectorAll('.pxq__g input[data-k]'), function (inp) {
        var k = inp.getAttribute('data-k'), p = fmt(prices(k, r));
        var tile = inp.closest('.pxq__g');
        if (k === 'other' || k === 'chip') return;
        if (!p) { if (tile && !tile.hidden) { tile.hidden = true; } return; }
        if (tile && tile.hidden) tile.hidden = false;
        if (inp.getAttribute('data-range') !== p) inp.setAttribute('data-range', p);
        var st = tile && tile.querySelector('.pxq__g-p strong');
        if (st && st.textContent !== p) st.textContent = p;
      });
      // detail panel for the selected service
      var cur = m.querySelector('.pxq__g input[data-k]:checked');
      if (!cur) return;
      var k = cur.getAttribute('data-k');
      var detail = q('[data-pxq-detail]');
      var posBtn = detail && detail.querySelector('.pxq__pos-b.is-on');
      var pos = posBtn ? posBtn.getAttribute('data-pos') : '';
      if (k === 'windshield' && r.w) {
        var box = detail && detail.querySelector('.pxq__d-opts');
        if (box && box.getAttribute('data-x') !== '1') {
          var has = {};
          r.w.forEach(function (o) { o[0].split('').forEach(function (f) { has[f] = 1; }); });
          var list = FEAT_ORDER.filter(function (f) { return has[f[0]]; }).map(function (f) { return f[1]; });
          if (r.w.length > 1) {
            if (r.w.some(function (o) { return o[0] === ''; })) list.push('None of these');
            list.push('Not sure');
            box.innerHTML = list.map(function (x) { return '<label><input type="checkbox" value="' + x + '"><span>' + x + '</span></label>'; }).join('');
            var lbl = box.previousElementSibling;
            if (lbl && lbl.classList.contains('pxq__d-lbl')) lbl.innerHTML = 'Check what your windshield has <em>(for your exact price)</em>';
          } else {
            box.innerHTML = '';
            var lbl2 = box.previousElementSibling;
            if (lbl2 && lbl2.classList.contains('pxq__d-lbl')) lbl2.hidden = true;
          }
          box.setAttribute('data-x', '1');
        }
      }
      var feats = detail ? Array.prototype.map.call(detail.querySelectorAll('.pxq__d-opts input:checked'), function (i) { return FEAT[i.value] || ''; }) : [];
      var p = fmt(prices(k, r, pos, feats));
      if (!p) return;
      var dp = detail && detail.querySelector('.pxq__d-price');
      if (dp && dp.getAttribute('data-x') !== p) { dp.textContent = p; dp.setAttribute('data-x', p); }
      var priceIn = q('[data-pxq-price]');
      if (priceIn && priceIn.value !== p) priceIn.value = p;
      if (cur.getAttribute('data-range') !== p) cur.setAttribute('data-range', p);
    } finally { busy = false; }
  }
  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    setTimeout(function () { queued = false; apply(); }, 0);
  }
  new MutationObserver(function () { if (!busy) schedule(); }).observe(m, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  m.addEventListener('change', schedule);
  m.addEventListener('click', function () { setTimeout(apply, 0); });
})();
